import { Typography } from 'antd';
import useMarkdown from '../hooks/useMarkdown';
import './Markdown.css';

type Props = { children: string };

const InlineMarkdown: React.FC<Props> = ({ children }) => {
  const markdown = useMarkdown();

  return (
    <Typography>
      <span
        onClick={(event) => {
          event.stopPropagation();
        }}
        dangerouslySetInnerHTML={{
          __html: markdown.render(children),
        }}
      />
    </Typography>
  );
};

export default InlineMarkdown;
